import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import Link from '@mui/material/Link';

import { CISecondaryButton } from 'common/viewcomp/forms/buttons';

interface ForgotUsernamePasswordChoiceProps {
    onChoosePassword: () => void;
    onChooseUsername: () => void;
    onBackToLogin: () => void;
    className?: string;
}

export const ForgotUsernamePasswordChoice = ({
    onChoosePassword,
    onChooseUsername,
    onBackToLogin,
    className = '',
}: ForgotUsernamePasswordChoiceProps): ReactElement => {
    const { t } = useTranslation('auth');

    return (
        <div id="login_content" className={className}>
            <h1 className="header" id="forgot_username_password_header">
                {t('forgotuser.head')}
            </h1>
            <div>
                <CISecondaryButton
                    className="submit_button"
                    type="button"
                    id="fpswdButton"
                    fullWidth
                    onClick={onChoosePassword}
                >
                    {t('forgotuser.password')}
                </CISecondaryButton>
                <CISecondaryButton
                    className="submit_button"
                    type="submit"
                    id="fuserButton"
                    fullWidth
                    onClick={onChooseUsername}
                >
                    {t('forgotuser.username')}
                </CISecondaryButton>
            </div>
            <Link component="button" className="auth-link" id="backToLogin" onClick={onBackToLogin}>
                {t('forgotuser.back_login')}
            </Link>
        </div>
    );
};
